import "./menuStyle.css"

const MenuCard = ({ item }) => (
  <div className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 h-full">
    <div className="p-4">
      <div className="relative mb-4">
        <img
          src={item.image || "/placeholder.svg?height=200&width=200"}
          alt={item.name}
          className="w-full aspect-square object-cover rounded-lg"
        />
        {item.isSpecial && (
          <span className="absolute top-2 left-2 bg-red-500 text-white px-2 py-1 rounded-full text-xs font-semibold">
            人気No.1
          </span>
        )}
        {item.isLimited && (
          <span className="absolute top-2 right-2 bg-orange-500 text-white px-2 py-1 rounded-full text-xs font-semibold">
            入荷時のみ
          </span>
        )}
      </div>

      <h3 className="text-lg font-bold text-gray-800 mb-2">{item.name}</h3>

      <div className="space-y-1 mb-3">
        {item.prices.map((price, index) => (
          <div key={index} className="text-orange-600 font-semibold">
            {price}
          </div>
        ))}
      </div>

      {item.description && (
        <p className="text-sm text-gray-600 leading-relaxed">
          {item.description}
          {item.isLimited && <span className="text-red-600 font-semibold ml-1">※入荷がある場合のみ</span>}
        </p>
      )}
    </div>
  </div>
)

const MenuSection = ({ title, subtitle, items }) => (
  <section className="mb-12">
    <div className="text-center mb-8">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-800 mb-2">{title}</h2>
      {subtitle && <p className="text-gray-600">{subtitle}</p>}
    </div>
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
      {items.map((item, index) => (
        <MenuCard key={index} item={item} />
      ))}
    </div>
  </section>
)

export const Menu = () => {
  const tanpinMenu = [
    {
      name: "特製もも",
      prices: ["100g(3個) 350円", "500g 1700円"],
      image: "/images/tanpin/tokumomo.JPG?height=200&width=200",
      description: "当店1番人気!! たっぷりのにんにくを使用し香り豊かに仕上げました",
      isSpecial: true,
    },
    {
      name: "醤油からあげ",
      prices: ["100g(3個) 350円", "500g 1700円"],
      image: "/images/tanpin/syouyu.JPG?height=200&width=200",
      description: "旨味のある九州しょうゆを使用した定番からあげ",
    },
    {
      name: "もも辛",
      prices: ["100g(3個) 350円", "500g 1700円"],
      image: "/images/tanpin/momokara.JPG?height=200&width=200",
      description: "辛さがやみつき！数種類の香辛料をブレンド、辛さの中にも旨味あり",
    },
    {
      name: "ヘルシーむね",
      prices: ["100g(5~6個) 300円", "500g 1450円"],
      image: "/images/tanpin/mune.JPG?height=200&width=200",
      description: "柔らかくてジューシー♪",
    },
    {
      name: "せせり",
      prices: ["100g(3~4本) 390円(生計り)"],
      image: "/images/tanpin/seseri.JPG?height=200&width=200",
      description: "首まわりの肉で希少部位。ブリっと弾力のある食感。",
      isLimited: true,
    },
    {
      name: "手羽塩",
      prices: ["100g(4~5本) 380円", "500g 1850円"],
      image: "/images/tanpin/tebasio.JPG?height=200&width=200",
      description: "カリっと香ばしいチキンバー",
    },
    {
      name: "ずりから",
      prices: ["100g(10個前後) 340円", "500g 1650円"],
      image: "/images/tanpin/zurikara.JPG?height=200&width=200",
      description: "大分からあげ おつまみにも最適砂ずりのからあげ",
    },
    {
      name: "手羽先",
      prices: ["100g(2本) 330円", "500g 1600円"],
      image: "/images/tanpin/tebasaki.JPG?height=200&width=200",
      description: "大分からあげ 食べ応えのある逸品",
    },
  ]

  const sideMenu = [
    {
      name: "フライドポテト",
      prices: ["S:200円", "M:320円", "L:420円"],
      image: "/images/sidemenu/poteto.JPG?height=200&width=200",
      description: "",
    },
    {
      name: "ゴボウのからあげ",
      prices: ["S:280円", "M:560円", "L:840円"],
      image: "/images/sidemenu/gobo.JPG?height=200&width=200",
      description: "",
    },
    {
      name: "タレから",
      prices: ["S:380円", "M:740円"],
      image: "/images/sidemenu/tarekara.JPG?height=200&width=200",
      description: "おかずに最適! 甘みのある九州醤油と数種類の調味料を煮込んだ特製タレに絡めました",
    },
    {
      name: "チキン南蛮",
      prices: ["S:470円", "M:920円"],
      image: "/images/sidemenu/nanban.JPG?height=200&width=200",
      description: "自慢の逸品 甘酢、タルタルソースは全て手作り",
    },
  ]

  const bentoMenu = [
    {
      name: "特製もも弁当",
      prices: ["小盛:480円", "並盛:600円", "大盛:780円", "ドカ盛:1000円"],
      image: "/images/bento/tokumomo_bento.jpg?height=200&width=200",
      description: "※写真は小盛",
      isSpecial: true,
    },
    {
      name: "醤油からあげ弁当",
      prices: ["小盛:480円", "並盛:600円", "大盛:780円", "ドカ盛:1000円"],
      image: "/images/bento/syoyu_bento.jpg?height=200&width=200",
      description: "※写真は大盛",
    },
    {
      name: "もも辛弁当",
      prices: ["小盛:480円", "並盛:600円", "大盛:780円", "ドカ盛:1000円"],
      image: "/images/bento/momokara_bento.jpg?height=200&width=200",
      description: "※写真はドカ盛",
    },
    {
      name: "手羽塩弁当",
      prices: ["小盛:480円", "並盛:600円", "大盛:780円", "ドカ盛:1000円"],
      image: "/images/bento/tebashio_bento.jpg?height=200&width=200",
      description: "※写真は並盛",
    },
    {
      name: "タレから弁当",
      prices: ["小盛:500円", "並盛:620円", "大盛:800円", "ドカ盛:1050円"],
      image: "/images/bento/tare_bento.jpg?height=200&width=200",
      description: "※写真は大盛",
    },
    {
      name: "チキン南蛮弁当",
      prices: ["小盛:550円", "並盛:650円", "大盛:850円", "ドカ盛:1100円"],
      image: "/images/bento/nanban_bento.jpg?height=200&width=200",
      description: "※写真は大盛",
    },
  ]

  const otherMenu = [
    {
      name: "ファミリー盛り",
      prices: ["4~5人前 3300円"],
      image: "/images/others/family.jpg?height=200&width=200",
      description: "特製もも、むね、手羽先、しょうゆ、ずりからの盛り合わせ",
    },
    {
      name: "オードブル",
      prices: ["3名様以上 3200円", "5名様以上 4300円"],
      image: "/images/others/odoburu_s.jpg?height=200&width=200",
      description: "チキン南蛮、タレからあげ、ゴボウのからあげ入り",
    },
  ]

  return (
    <section className="py-12 px-4 bg-white bg-opacity-90">
      <div className="container mx-auto max-w-7xl">
        <MenuSection title="単品メニュー" subtitle="(税込)" items={tanpinMenu} />
        <MenuSection title="サイドメニュー" subtitle="(税込)" items={sideMenu} />
        <MenuSection title="お弁当" subtitle="(税込) ※サイズ毎でご飯とからあげの量が異なります" items={bentoMenu} />
        <MenuSection title="盛り合わせ" subtitle="(税込)" items={otherMenu} />
      </div>
    </section>
  )
}
